module.exports = __webpack_public_path__ + "static/media/doctor.c59800a9.png";